import { render, staticRenderFns } from "./locationHeader.vue?vue&type=template&id=6f54601f&"
import script from "./locationHeader.vue?vue&type=script&lang=js&"
export * from "./locationHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports